/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable max-lines */
import {
  Grid,
  Radio,
  Typography,
  useMediaQuery,
  Box,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import NewAddressImage from '../../../images/iconFeature.svg';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { FeatureScreenStyles as classes } from './FeatureScreenStyles';
import EliteImage2 from '../../../images/EliteAccImg2.png';
import { LayoutStyles as layoutClasses } from '../../Bundle/LayoutStyles';
import Layout from '../../Layout';
import RetailImage3 from '../../../images/Comercial_Image_3.png';
import ProductIndex from '../ProductQuestion/Product';
import SaveAppContactInfo from '../../SaveApp/SaveAppContactInfo';
import { productNameURLMapping } from '../../../services/productNameURLMapping';
import {
  ACCOUNT_STATEMENTS,
  AND,
  APPLY_TWO_ACCOUNTS,
  COMBINED_STATEMENT,
  DEBIT_CARD,
  DEBIT_CARD_INFO_TEXT_1,
  DEBIT_CARD_NOT_REQUIRED_TEXT,
  DEBIT_CARD_REQUIRED_TEXT,
  DEFICIT_TRANSFER_TEXT,
  DIRECT_DEPOSITE,
  DIRECT_DEPOSITE_RADIO_TEXT,
  DIRECT_DEPOSITE_RADIO_TEXT_NO,
  DIRECT_DEPOSITE_TEXT,
  DIRECT_DEPOSIT_SUBTEXT,
  ELITE_ACCOUNT_EN,
  EXCESS_TRANSFER_NOTE,
  EXCESS_TRANSFER_TEXT,
  E_STATEMENTS,
  E_STATEMENT_SUBTEXT_PAID,
  FEATURE_INFO,
  LIBRE_AHORRA_BUNDLE,
  MANDATORY_FIELD_ERR,
  MASTERCARD_SUBTEXT,
  MASTERCART_DEBIT_CARD,
  SIGNER_FEE_MESSAGE,
  STATEMENT_SUB,
  STATEMENT_SUBTEXT,
  STATEMENT_TITLE,
} from '../../../constants';
import { CustomInput } from '../CustomInput/CustomInput';
import { commonUtility } from '../UtilityFunctions';
import { saveFeatureInformation } from '../../../services/formService';
import { productMapping } from '../../../services/productMapping';
import { commonTernary, handleETBFlow, isBundle, isEtbFlow } from '../../commonCode';
import NewLayout from '../../Bundle/NewLayout';
import CustomSwitch from '../Switch/CustomSwitch';
import CommonTab from '../../Bundle/ProductTrans';
import { businessMapping } from '../../../services/businessMapping';
import { productTypeMapping } from '../../../services/productTypeMapping';
import { InfoFilledIcon } from '../../../images/svg/CustomizedSVG';
import CustomUncheckedIcon from '../../Bundle/CheckBoxIcons/CustomUncheckedIcon';
import CustomCheckedIcon from '../../Bundle/CheckBoxIcons/CustomCheckedIcon';

const CustomRadio = styled(Radio)(({ theme }) => ({
  color: '#661C69',
  '&.Mui-checked': {
    color: '#661C69',
  },
}));

const FeatureScreenProgresa = (props) => {
  const themes = useTheme();

  const isMobile = useMediaQuery(themes?.breakpoints?.down('1034'), {
    defaultMatches: true,
  });
  const isMobile600 = useMediaQuery(themes?.breakpoints?.down('600'), {
    defaultMatches: true,
  });
  const { t } = useTranslation();

  const leadGenerationContext = useContext(LeadGenerationContext);
  const { history } = props;
  const {
    productName,
    setIsModalSaveLater,
    setCurrentPage,
    isModalSaveLater,
    location,
    language,
    depositeCardDisburseFeature,
    setDepositeCardDisburseFeature,
    debitCardDisburseFeature,
    setDebitCardDisburseFeature,
    excessTransferFeature,
    setExcessTransferFeature,
    excessAmt,
    setExcessAmt,
    currentFlow,
    excessAmtError,
    setExcessAmtError,
    setIsScreenFiveDirty,
    setIsFeatureScreenDirty,
    setIsFundingScreenDirty,
    isFeatureScreenDirty,
    isFundingRequired,
    setIsFundingRequired,
    productData,
    items,
    setItems,
    savedDataFlow,
    setItemsAnswer,
    savedItemsAnswer,
    setFormAnswer,
    itemsAnswer,
    productAccountType,
    setProductAccountType,
    setDebitCardDisburse,
    debitCardDisburse,
    setDebitCardNotRequired,
    debitCardNotRequired,
    setDebitCardDisburseFeatureSavings,
    productTabVal,
    debitCardDisburseFeatureSavings,
    setDebitCardDisburseSavings,
    debitCardDisburseSavings,
    masterDebitCardDisburseFeature,
    masterDebitCardDisburseFeatureSavings,
    setMasterDebitCardDisburseFeature,
    setMasterDebitCardDisburseFeatureSavings,
    isLightTheme,
    theme,
    productAccountTypeFeature,
    setProductAccountTypeFeature,
  } = leadGenerationContext;
  const [isValidating, setIsValidating] = React.useState(false);
  const [isReadless, setIsReadless] = useState(false);
  const [isReadlessAnother, setIsReadlessAnother] = useState(false);

  const togglereadMore = () => {
    setIsReadless(!isReadless);
  };
  const togglereadMoreAnother = () => {
    setIsReadlessAnother(!isReadlessAnother);
  };
  const [isReadlessEstatement, setIsReadlessEstatement] = useState(false);

  const togglereadMoreAnotherEstatement = () => {
    setIsReadlessEstatement(!isReadlessEstatement);
  };
  const saveData = async () => {
    const data = {};
    data.applicationId = leadGenerationContext.applicationId;
    data.applicantId = leadGenerationContext.applicantId;
    data.language = leadGenerationContext.language;
    data.location = leadGenerationContext.location;
    data.utmCampaign = leadGenerationContext.utmCampaign;
    data.utmMedium = leadGenerationContext.utmMedium;
    data.utmContent = leadGenerationContext.utmContent;
    data.utmTerm = leadGenerationContext.utmTerm;
    data.utmSource = leadGenerationContext.utmSource;
    data.branchCode = leadGenerationContext.branchCode;
    data.productType = leadGenerationContext.productType;
    data.productName = leadGenerationContext.productName;
    data.deposite = depositeCardDisburseFeature;
    data.excessAmount = excessAmt.excessAmtVal;
    data.autoTransfer = excessTransferFeature;
    data.debit = debitCardDisburseFeature;
    data.fundingStatus = isFundingRequired;
    data.debitCardDisburseFeature = debitCardDisburseFeature;
    data.masterDebitCardDisburseFeature = masterDebitCardDisburseFeature;
    data.masterDebitCardDisburseFeatureSavings = masterDebitCardDisburseFeatureSavings;
    data.productAccountTypeFeature = productAccountTypeFeature;
    data.debitCardDisburseFeatureSavings = debitCardDisburseFeatureSavings;
    data.customerType = leadGenerationContext.customerType;
    data.flowTypeETB = leadGenerationContext.flowTypeETB;
    data.customerAppId = leadGenerationContext.customerAppId;
    let response = null;
    response = await saveFeatureInformation(
      data,
      leadGenerationContext.accessToken,
      excessTransferFeature,
      excessAmtError
    );
    return response;
  };
  const focusErrorCheck = (fields) => {
    for (const field of fields) {
      if (!excessAmt[field]) {
        const element = document.getElementById(field);
        if (element) {
          element.focus();
          break;
        }
      }
    }
  };
  const focusError = () => {
    let isElementFound = false;
    const fields = ['excessAmtVal'];

    for (const field of fields) {
      if (!excessAmt[field]) {
        const element = document.getElementById(field);
        if (element) {
          isElementFound = true;
          element.focus();
          break;
        }
      }
    }
    if (!isElementFound) {
      focusErrorCheck(fields);
    }
  };

  const validAllData = () => {
    let validval = true;
    if (excessTransferFeature === DIRECT_DEPOSITE_RADIO_TEXT) {
      if (!excessAmt.excessAmtVal) {
        validval = false;
        setExcessAmtError((prevState) => ({
          ...prevState,
          excessAmtVal: MANDATORY_FIELD_ERR,
        }));
      }
    } else if (
      excessTransferFeature === DIRECT_DEPOSITE_RADIO_TEXT_NO &&
      excessAmtError.excessAmtVal !== ''
    ) {
      validval = true;
    }
    return validval;
  };

  const isFormValid = () => {
    let valid = validAllData();
    if (excessTransferFeature === DIRECT_DEPOSITE_RADIO_TEXT) {
      for (const key in excessAmtError) {
        if (excessAmtError[key]) {
          valid = false;
          break;
        }
      }
    }
    return valid;
  };

  const handleRouting = () => {
    if (isEtbFlow(leadGenerationContext)) {
      handleETBFlow(leadGenerationContext, history, 'funding-info');
    }
    // else if (productMapping(productName) === 'Ahorra') {
    //   history.push({
    //     pathname: `/${location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/retail-form/${productNameURLMapping(
    //       productName
    //     )}/funding-info`,
    //   });
    // }
    else {
      history.push({
        pathname: `/${location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/funding-info`,
      });
    }
  };

  const handleContinue = async (e) => {
    e.preventDefault();
    setIsValidating(true);
    const valid =
      productMapping(productName) === 'Libre' ||
      productMapping(productName) === 'Ahorra' ||
      productMapping(productName) === LIBRE_AHORRA_BUNDLE
        ? true
        : isFormValid();

    if (valid) {
      if (isFeatureScreenDirty) {
        const result = await saveData();
        if (result && result.status === 201) {
          if (result.data) {
            setIsValidating(false);
            setIsFeatureScreenDirty(false);
            if (isEtbFlow(leadGenerationContext)) {
              handleETBFlow(leadGenerationContext, history, 'funding-info');
            } else {
              history.push({
                pathname: `/${location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/retail-form/${productNameURLMapping(
                  productName
                )}/funding-info`,
              });
            }
          }
        } else {
          setIsValidating(false);
        }
      } else {
        setIsValidating(false);
        handleRouting();
      }
    } else {
      focusError();
      setIsValidating(false);
      setIsFeatureScreenDirty(false);
    }
  };

  const handleDebitCardRequiredRadioBundle = (e) => {
    setIsFeatureScreenDirty(true);
    setIsFundingScreenDirty(true);
    if (productTabVal === 0) {
      if (e.target.name === 'ship the debit card') {
        setDebitCardDisburseFeature(!debitCardDisburseFeature);
      } else if (e.target.name === 'debit-card-shipping') {
        setMasterDebitCardDisburseFeature(!masterDebitCardDisburseFeature);
      }
    } else if (productTabVal === 1) {
      if (e.target.name === 'ship the debit card') {
        setDebitCardDisburseFeatureSavings(!debitCardDisburseFeatureSavings);
      } else if (e.target.name === 'debit-card-shipping') {
        setMasterDebitCardDisburseFeatureSavings(!masterDebitCardDisburseFeatureSavings);
      }
    }
  };
  const handleCommonDebitCardRequiredRadio = (e) => {
    setIsFeatureScreenDirty(true);
    setIsFundingScreenDirty(true);
    if (e.target.name === 'ship the debit card') {
      setDebitCardDisburseFeature(!debitCardDisburseFeature);
      setDebitCardDisburseFeatureSavings(!debitCardDisburseFeatureSavings);
    } else if (e.target.name === 'debit-card-shipping') {
      setMasterDebitCardDisburseFeature(!masterDebitCardDisburseFeature);
      setMasterDebitCardDisburseFeatureSavings(!masterDebitCardDisburseFeatureSavings);
    }
  };
  const handleDebitCardRequiredRadio = (e) => {
    setIsFeatureScreenDirty(true);
    setIsFundingScreenDirty(true);
    setDebitCardDisburseFeature(e.target.value);
  };
  const handleDebitoCardRequiredRadioOnEnter = (e) => {
    setIsFeatureScreenDirty(true);
    setIsFundingScreenDirty(true);
    if (e.key === 'Enter') {
      setDebitCardDisburseFeature(e.target.value);
    }
  };
  const handleFundingCardRequiredRadio = (e) => {
    setIsFeatureScreenDirty(true);
    setIsFundingScreenDirty(true);
    setIsFundingRequired(e.target.value);
  };
  const handleFundingCardRequiredRadioOnEnter = (e) => {
    setIsFeatureScreenDirty(true);
    setIsFundingScreenDirty(true);
    if (e.key === 'Enter') {
      setIsFundingRequired(e.target.value);
    }
  };

  const handleExcessCardRequiredRadio = (e) => {
    setIsFeatureScreenDirty(true);
    setIsFundingScreenDirty(true);
    if (
      excessTransferFeature === DIRECT_DEPOSITE_RADIO_TEXT_NO ||
      excessTransferFeature === DIRECT_DEPOSITE_RADIO_TEXT
    ) {
      setExcessAmt({
        ...excessAmt,
        excessAmtVal: '',
      });
      setExcessAmtError({
        ...excessAmtError,
        excessAmtVal: '',
      });
    }
    setExcessTransferFeature(e.target.value);
  };
  const handleExcessCardRequiredRadioOnEnter = (e) => {
    setIsFeatureScreenDirty(true);
    setIsFundingScreenDirty(true);
    if (e.key === 'Enter') {
      if (
        excessTransferFeature === DIRECT_DEPOSITE_RADIO_TEXT_NO ||
        excessTransferFeature === DIRECT_DEPOSITE_RADIO_TEXT
      ) {
        setExcessAmt({
          ...excessAmt,
          excessAmtVal: '',
        });
        setExcessAmtError({
          ...excessAmtError,
          excessAmtVal: '',
        });
      }
      setExcessTransferFeature(e.target.value);
    }
  };
  const handleDepositeCardRequiredRadio = (e) => {
    setIsFeatureScreenDirty(true);
    setIsFundingScreenDirty(true);
    setDepositeCardDisburseFeature(e.target.value);
  };
  const handleDepositeCardRequiredRadioOnEnter = (e) => {
    setIsFeatureScreenDirty(true);
    setIsFundingScreenDirty(true);
    if (e.key === 'Enter') {
      setDepositeCardDisburseFeature(e.target.value);
    }
  };
  const handleChangeExcessAmt = (e) => {
    setIsFeatureScreenDirty(true);
    setIsFundingScreenDirty(true);
    if (e.target.value?.match(/^\d*$/)) {
      if (excessTransferFeature === DIRECT_DEPOSITE_RADIO_TEXT) {
        if (parseInt(e.target.value, 10) > parseInt(999, 10)) {
          setExcessAmt({
            ...excessAmt,
            [e.target.name]: e.target.value,
          });
          setExcessAmtError({
            ...excessAmtError,
            [e.target.name]: '',
          });
        } else {
          setExcessAmt({
            ...excessAmt,
            [e.target.name]: e.target.value,
          });
          setExcessAmtError({
            ...excessAmtError,
            [e.target.name]: '* Minimum excess limit amount is $1,000.00',
          });
        }
        if (e.target.value === '') {
          setExcessAmt({
            ...excessAmt,
            [e.target.name]: e.target.value,
          });
          setExcessAmtError({
            ...excessAmtError,
            [e.target.name]: MANDATORY_FIELD_ERR,
          });
        }
      }
    } else if (e.target.value === '' && excessTransferFeature === DIRECT_DEPOSITE_RADIO_TEXT) {
      setExcessAmt({ [e.target.name]: '' });
      setExcessAmtError({
        [e.target.name]: MANDATORY_FIELD_ERR,
      });
    } else {
      setExcessAmt({
        ...excessAmt,
        [e.target.name]: e.target.value,
      });
      setExcessAmtError({
        ...excessAmtError,
        [e.target.name]: '* Invalid Format',
      });
    }
  };
  const handleSaveApplication = (e) => {
    e.preventDefault();
    setIsModalSaveLater(true);
  };
  useEffect(() => {
    setCurrentPage(FEATURE_INFO);
    window.scrollTo(0, 0);
  }, []);

  const back = (e) => {
    e.preventDefault();
    if (
      leadGenerationContext.customerType === 'ETB' &&
      leadGenerationContext.flowTypeETB === 'EtbFlow'
    ) {
      history.push(
        `/${location?.toLowerCase()}/${language?.toLowerCase()}/express/retail-form/${productNameURLMapping(
          productName
        )}/product-info`
      );
    } else {
      history.push(
        `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/product-info`
      );
    }
  };
  const returnproduct = () => {
    let text = '';
    if (productMapping(productName) === 'Libre') {
      text = 'Libre account';
    } else if (productMapping(productName) === 'Ahorra') {
      text = 'Ahorra account';
    } else if (productMapping(productName) === 'Elite Account') {
      text = 'Elite account';
    }
    return text;
  };
  const handleresult = (result, newItem) => {
    if (result === false) {
      handleData(newItem);
    } else {
      handleChangeData(newItem);
    }
  };
  const handleData = (newItem) => {
    const formAnswer = { ...leadGenerationContext.formAnswer };
    const newFormAnswer = {};
    for (const property in formAnswer) {
      if (!property.startsWith(`${newItem.name}_`)) {
        newFormAnswer[property] = formAnswer[property];
      }
    }
    setFormAnswer(newFormAnswer);
    const value = newItem.next.find((element) => element.value === 'false');
    const questionIndex = productData?.questions?.findIndex((item) => {
      if (value?.questions?.length > 0) {
        return item.name === value.questions[0];
      }
      return false;
    });
    let newItems = [];
    if (questionIndex > 0) {
      if (!items.includes(questionIndex)) {
        newItems = [...items, questionIndex];
      } else {
        newItems = [...items];
      }
    } else {
      newItems = [...items];
    }
    setItems(newItems);
  };
  const handleChangeData = (newItem) => {
    const index = items.findIndex((item) => {
      if (productData?.questions?.[item]?.subQuestions) {
        return productData.questions[item].subQuestions.includes(newItem.name);
      }
      return productData.questions[item].name === newItem.name;
    });
    let newItems = [];
    if (index >= 0) {
      items.splice(index + 1, items.length - 1 - index);
      newItems = [...items];
    } else {
      newItems = [...items];
    }
    setItems(newItems);
  };
  const handleDebitCardRequiredRadioOnEnter = (e) => {
    if (
      businessMapping(leadGenerationContext.productName) &&
      (productTypeMapping(leadGenerationContext.productType) === 'Ahorra Account' ||
        productTypeMapping(leadGenerationContext.productType) === 'Libre Account')
    ) {
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    }
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    if (e.key === 'Enter') {
      if (isBundle(currentFlow)) {
        setDebitCardDisburse(!debitCardDisburse);
        setDebitCardNotRequired(!debitCardNotRequired);
      } else {
        setDebitCardNotRequired(false);
        setDebitCardDisburse(true);
      }
    }
  };
  const handleitem = (property, newItem, newItemsAnswer, result, newElementsAnswer) => {
    let toy;
    if (property === newItem.name) {
      toy = { ...newItemsAnswer, [property]: result };
    } else {
      toy = {
        ...newItemsAnswer,
        [property]: newElementsAnswer[property],
      };
    }
    return toy;
  };
  const handlesubQuestions = (subQuestionAnswered) => {
    let newitemdata;
    if (subQuestionAnswered === true) {
      newitemdata = true;
      return newitemdata;
    }
    if (subQuestionAnswered === false) {
      newitemdata = false;
      return newitemdata;
    }
  };
  const handlesubQue = (subQuestions, newItemsAnswer) => {
    if (subQuestions?.length > 0) {
      let dataitem;
      for (const itemSubQue of subQuestions) {
        if (newItemsAnswer[itemSubQue]) {
          dataitem = true;
          break;
        }
      }
      return dataitem;
    }
  };
  const samplefunction = (productData1, newItemsAnswer) => {
    const newItemsAnswer1 = newItemsAnswer;
    if (productData1?.questions) {
      for (const item of productData1.questions) {
        const question = item;
        const { subQuestions } = question;
        let subQuestionAnswered = false;
        const callsubque = true;
        if (callsubque === true) {
          subQuestionAnswered = handlesubQue(subQuestions, newItemsAnswer1);
        }
        if (subQuestions?.length > 0) {
          newItemsAnswer1[question.name] = handlesubQuestions(subQuestionAnswered);
        }
        if (subQuestionAnswered) {
          newItemsAnswer1[question.name] = true;
        }
      }
    }
    return newItemsAnswer1;
  };
  const itemsHandler = (newItem, result) => {
    if (
      businessMapping(leadGenerationContext.productName) &&
      (productTypeMapping(leadGenerationContext.productType) === 'Ahorra Account' ||
        productTypeMapping(leadGenerationContext.productType) === 'Libre Account')
    ) {
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    }
    setIsScreenFiveDirty(true);
    leadGenerationContext.setIsFeatureScreenDirty(true);
    setIsFundingScreenDirty(true);
    const newElementsAnswer = { ...itemsAnswer, [newItem.name]: result };
    setItemsAnswer(newElementsAnswer);
    let newItemsAnswer = {};
    const callresult = true;
    if (callresult === true) {
      handleresult(result, newItem);
    }

    for (const property in newElementsAnswer) {
      if (callresult === true) {
        newItemsAnswer = handleitem(property, newItem, newItemsAnswer, result, newElementsAnswer);
      }
    }
    newItemsAnswer = samplefunction(productData, newItemsAnswer);
    setItemsAnswer(newItemsAnswer);
  };
  const checkboxes = [
    {
      tabValue: 0,
      debitcardValue: debitCardDisburseFeature,
      masterdebitcardValue: masterDebitCardDisburseFeature,
    },
    {
      tabValue: 1,
      debitcardValue: debitCardDisburseFeatureSavings,
      masterdebitcardValue: masterDebitCardDisburseFeatureSavings,
    },
  ];
  const ProductIndexFunc = () => (
    <>
      {checkboxes.map((x) => {
        if (x.tabValue === productTabVal) {
          return (
            <>
              <Grid container sx={classes.containerStyle}>
                <Grid item xs={6} md={12} sx={classes.style}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disableFocusRipple
                        disableTouchRipple
                        // icon={CustomUncheckedIcon(theme?.palette?.orientalPrimary?.main)}
                        // checkedIcon={CustomCheckedIcon(theme?.palette?.orientalPrimary?.main)}
                        icon={<CustomUncheckedIcon color={theme?.palette?.orientalPrimary?.main} />}
                        checkedIcon={
                          <CustomCheckedIcon color={theme?.palette?.orientalPrimary?.main} />
                        }
                        size="small"
                        checked={x.debitcardValue}
                        onChange={
                          !productAccountTypeFeature
                            ? handleDebitCardRequiredRadioBundle
                            : handleCommonDebitCardRequiredRadio
                        }
                        onKeyDown={handleDebitCardRequiredRadioOnEnter}
                        inputProps={{
                          'data-testid': 'mail_my_card_testid',
                        }}
                        id="ship the debit card"
                        name="ship the debit card"
                        sx={{
                          ...classes.checkbox,
                          '&.Mui-focusVisible': {
                            border: `1px solid ${theme?.palette?.orientalPrimary?.main}`,
                            borderRadius: '5px',
                            padding: '2px 1px 2px 1px',
                          },
                        }}
                        type="checkbox"
                        data-testid="debitCard_testid"
                        aria-label="ship the debit card"
                      />
                    }
                    label={
                      <Box component="div" id="direct-deposit-label" sx={classes.borderstyle}>
                        <Typography
                          component="p"
                          variant="subtitle1"
                          color="primary"
                          sx={classes.depositstyle}
                        >
                          {t(DIRECT_DEPOSITE, {
                            defaultValue: DIRECT_DEPOSITE,
                          })}
                        </Typography>
                        <Typography
                          component="p"
                          variant="subtitle1"
                          sx={{ ...classes.subtextStyle, color: theme?.palette?.subtext?.main }}
                        >
                          {t(DIRECT_DEPOSIT_SUBTEXT, {
                            defaultValue: DIRECT_DEPOSIT_SUBTEXT,
                          })}
                        </Typography>
                      </Box>
                    }
                    sx={{ alignItems: 'flex-start' }}
                  />
                </Grid>
                <Grid item xs={12} md={12} sx={classes.style}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disableFocusRipple
                        disableTouchRipple
                        icon={<CustomUncheckedIcon color={theme?.palette?.orientalPrimary?.main} />}
                        checkedIcon={
                          <CustomCheckedIcon color={theme?.palette?.orientalPrimary?.main} />
                        }
                        size="small"
                        checked={x.masterdebitcardValue}
                        onChange={
                          !productAccountTypeFeature
                            ? handleDebitCardRequiredRadioBundle
                            : handleCommonDebitCardRequiredRadio
                        }
                        onKeyDown={handleDebitCardRequiredRadioOnEnter}
                        inputProps={{
                          'data-testid': 'debit_card_checkbox_testid',
                        }}
                        id="debit-card-shipping"
                        name="debit-card-shipping"
                        sx={{
                          ...classes.checkbox,
                          '&.Mui-focusVisible': {
                            border: `1px solid ${theme?.palette?.orientalPrimary?.main}`,
                            borderRadius: '5px',
                            padding: '2px 1px 2px 1px',
                          },
                        }}
                        type="checkbox"
                        aria-label="ship debit card"
                      />
                    }
                    label={
                      <Box component="div" id="debit-card-label" sx={classes.borderstyle}>
                        <Typography
                          component="p"
                          variant="subtitle1"
                          color="primary"
                          sx={classes.debitstyle}
                        >
                          {t(MASTERCART_DEBIT_CARD, {
                            defaultValue: MASTERCART_DEBIT_CARD,
                          })}
                        </Typography>
                        <Typography
                          component="p"
                          variant="subtitle1"
                          sx={{ ...classes.subtextStyle, color: theme?.palette?.subtext?.main }}
                        >
                          {t(MASTERCARD_SUBTEXT, {
                            defaultValue: MASTERCARD_SUBTEXT,
                          })}
                        </Typography>
                        {/* <Box sx={{ display: 'flex' }}>
                        </Box> */}
                      </Box>
                    }
                    sx={{ alignItems: 'flex-start' }}
                  />
                </Grid>
                <Grid item xs={12} md={12} sx={classes.containerBoxStyle} marginTop="20px">
                  <Box component="div">
                    <Box sx={classes.outerDivAnother}>
                      {/* <div> */}
                      {/* <Box
                        component="img"
                        id="signerFeeId"
                        sx={classes.imgDivDesign}
                        src={NewAddressImage}
                        alt={t('ACCOUNT_STATEMENTS', { defaultValue: 'ACCOUNT_STATEMENTS' })}
                        aria-label={t('ACCOUNT_STATEMENTS', {
                          defaultValue: 'ACCOUNT_STATEMENTS',
                        })}
                      /> */}
                      <Box marginRight="10px">
                        <InfoFilledIcon color={theme?.palette?.orientalPrimary?.main} />
                      </Box>
                      {/* </div> */}
                      {/* <div> */}

                      <Box sx={classes.statement}>
                        <Grid sx={classes.stmtstyle}>
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="h3"
                            sx={classes.debitstyle}
                          >
                            {t(ACCOUNT_STATEMENTS, { defaultValue: ACCOUNT_STATEMENTS })}
                          </Typography>
                        </Grid>
                        <Grid sx={{ paddingTop: '16px' }}>
                          <Typography variant="subtitle1" color="subtext" component="p">
                            <Box component="span" sx={classes.stmtTextStyle}>
                              {t(STATEMENT_TITLE, {
                                defaultValue: STATEMENT_TITLE,
                              })}
                            </Box>
                            <Box component="span" sx={classes.onlinetext}>
                              {t(STATEMENT_SUB, {
                                defaultValue: STATEMENT_SUB,
                                nsSeparator: '|',
                              })}
                            </Box>
                            <Box component="span" sx={classes.quesTitleSubHeadingStyle}>
                              {t(AND, {
                                defaultValue: AND,
                              })}
                            </Box>
                            <Box component="span" sx={classes.onlinetext}>
                              {t(STATEMENT_SUBTEXT, {
                                defaultValue: STATEMENT_SUBTEXT,
                                nsSeparator: '|',
                              })}
                            </Box>
                          </Typography>
                        </Grid>
                        <Typography
                          variant="body1"
                          sx={{
                            ...classes.subTextStyle,
                            color: !isLightTheme
                              ? '#FFFFFF'
                              : isBundle(productName)
                              ? '#979797'
                              : '#808285',
                          }}
                        >
                          {t(E_STATEMENT_SUBTEXT_PAID, {
                            defaultValue: E_STATEMENT_SUBTEXT_PAID,
                          })}
                        </Typography>
                      </Box>
                      {/* </div> */}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              <Grid sx={classes.containerStyle}>
                <Grid item xs={12} md={12} sx={classes.boxStyle}>
                  <Box sx={classes.outerDivAnother}>
                    <Box marginRight="10px">
                      <InfoFilledIcon color={theme?.palette?.orientalPrimary?.main} />
                    </Box>

                    <Box component="span" sx={classes.textElementStyle}>
                      <Typography component="p" variant="subtitle1">
                        {t(SIGNER_FEE_MESSAGE, { defaultValue: SIGNER_FEE_MESSAGE })}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </>
          );
        }
      })}
    </>
  );
  const FeatureLayout = () => (
    <Layout
      ariaDescribedby="FundingScreenHeading"
      headingId="FundingScreenHeading"
      ariaDescribedbyId="FundingScreenDesc"
      classes={classes}
      descriptionKey="feature screen desc"
      descriptionValue="Please review the features below which apply to your account."
      stepValue={2}
      handleBack={back}
      handleContinue={handleContinue}
      handleSaveApplication={handleSaveApplication}
      disableCondition={isValidating}
      backBtnTestid="backBtn_id"
      continueBtnTestid="continueBtn_id"
      screenLoading={isValidating}
      layoutImage={
        productMapping(productName) === ELITE_ACCOUNT_EN || productMapping(productName) === 'Ahorra'
          ? EliteImage2
          : RetailImage3
      }
    >
      <Box sx={classes.fund_grid_margin} data-page={FEATURE_INFO}>
        {(productMapping(productName) === 'Libre' ||
          productMapping(productName) === 'Ahorra' ||
          productMapping(productName) === 'Elite Account') && (
          <>
            <Box
              role="application"
              aria-roledescription={t('Debit Card', {
                defaultValue: 'Debit Card',
              })}
              aria-describedby="debitCardDisclaimerId"
              sx={classes.debCard}
            >
              <Grid size={{ xs: 12 }} sx={classes.debitcard}>
                <Box
                  component="span"
                  sx={classes.quesTitleStyleDeposite}
                  aria-label={t(DEBIT_CARD, {
                    defaultValue: DEBIT_CARD,
                  })}
                >
                  {t(DEBIT_CARD, {
                    defaultValue: DEBIT_CARD,
                  })}
                </Box>
              </Grid>
              <Grid container>
                <Grid
                  id="debitCardDisclaimerId"
                  size={{ xs: 12, md: 12 }}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <Box component="span" sx={classes.quesTitleSubHeadingStyle}>
                    {t(DEBIT_CARD_INFO_TEXT_1, {
                      defaultValue: DEBIT_CARD_INFO_TEXT_1,
                      nsSeparator: '|',
                    })}
                  </Box>
                </Grid>
              </Grid>
              <Box
                style={{
                  display: isMobile ? 'inline-grid' : 'inline-flex',
                }}
                sx={classes.radioLayoutDeposite}
              >
                <Box style={{ marginBottom: isMobile ? '23px' : '0px', display: 'flex' }}>
                  <label>
                    <CustomRadio
                      size="small"
                      sx={classes.radioRoot}
                      checked={debitCardDisburseFeature === DEBIT_CARD_REQUIRED_TEXT}
                      onChange={handleDebitCardRequiredRadio}
                      onKeyDown={handleDebitoCardRequiredRadioOnEnter}
                      value={DEBIT_CARD_REQUIRED_TEXT}
                      inputProps={{
                        'data-testid': 'mail_my_card_testid',
                      }}
                      name="debit card"
                    />
                    <Typography
                      style={{ marginRight: '16px' }}
                      variant="subtitle1"
                      aria-label={t(DEBIT_CARD_REQUIRED_TEXT, {
                        defaultValue: DEBIT_CARD_REQUIRED_TEXT,
                      })}
                      sx={classes.radioLabelStyle}
                    >
                      {t(DEBIT_CARD_REQUIRED_TEXT, {
                        defaultValue: DEBIT_CARD_REQUIRED_TEXT,
                      })}
                    </Typography>
                  </label>
                </Box>
                <div style={{ display: 'flex' }}>
                  <label>
                    <CustomRadio
                      size="small"
                      sx={classes.radioRoot}
                      checked={debitCardDisburseFeature === DEBIT_CARD_NOT_REQUIRED_TEXT}
                      onChange={handleDebitCardRequiredRadio}
                      onKeyDown={handleDebitoCardRequiredRadioOnEnter}
                      value={DEBIT_CARD_NOT_REQUIRED_TEXT}
                      inputProps={{
                        'data-testid': 'second_checkbox_testid',
                      }}
                      name="debit card"
                    />
                    <Typography
                      variant="subtitle1"
                      aria-label={t(DEBIT_CARD_NOT_REQUIRED_TEXT, {
                        defaultValue: DEBIT_CARD_NOT_REQUIRED_TEXT,
                      })}
                      sx={classes.radioLabelStyle}
                    >
                      {t(DEBIT_CARD_NOT_REQUIRED_TEXT, {
                        defaultValue: DEBIT_CARD_NOT_REQUIRED_TEXT,
                      })}
                    </Typography>
                  </label>
                </div>
              </Box>
            </Box>

            <Box
              role="application"
              aria-roledescription={t('Direct Deposit', {
                defaultValue: 'Direct Deposit',
              })}
              aria-describedby="directDepositDisclaimerId"
              sx={classes.debCard}
            >
              <Grid size={{ xs: 12 }} sx={classes.titleborderdepositeBor}>
                <Box
                  component="span"
                  sx={classes.quesTitleStyleDeposite}
                  aria-label={t(DIRECT_DEPOSITE, {
                    defaultValue: DIRECT_DEPOSITE,
                  })}
                >
                  {t(DIRECT_DEPOSITE, {
                    defaultValue: DIRECT_DEPOSITE,
                  })}
                </Box>
              </Grid>
              <Grid container>
                <Grid
                  id="directDepositDisclaimerId"
                  size={{ xs: 12, md: 12 }}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <Box component="span" sx={classes.quesTitleSubHeadingStyle}>
                    {t(DIRECT_DEPOSITE_TEXT, {
                      defaultValue: DIRECT_DEPOSITE_TEXT,
                      nsSeparator: '|',
                    })}
                  </Box>
                </Grid>
              </Grid>
              <Box
                style={{
                  display: isMobile ? 'inline-grid' : 'inline-flex',
                }}
                sx={classes.radioLayoutDeposite}
              >
                <Box style={{ marginBottom: isMobile ? '23px' : '0px', display: 'flex' }}>
                  <label>
                    <CustomRadio
                      size="small"
                      sx={classes.radioRoot}
                      checked={depositeCardDisburseFeature === DIRECT_DEPOSITE_RADIO_TEXT}
                      onChange={handleDepositeCardRequiredRadio}
                      onKeyDown={handleDepositeCardRequiredRadioOnEnter}
                      value={DIRECT_DEPOSITE_RADIO_TEXT}
                      inputProps={{
                        'data-testid': 'direct_deposit_testid',
                      }}
                      name="direct deposit"
                    />
                    <Typography
                      variant="subtitle1"
                      style={{ marginRight: '16px' }}
                      aria-label={t(DIRECT_DEPOSITE_RADIO_TEXT, {
                        defaultValue: DIRECT_DEPOSITE_RADIO_TEXT,
                      })}
                      sx={classes.radioLabelStyle}
                    >
                      {t(DIRECT_DEPOSITE_RADIO_TEXT, {
                        defaultValue: DIRECT_DEPOSITE_RADIO_TEXT,
                      })}
                    </Typography>
                  </label>
                </Box>
                <Box style={{ display: 'flex' }}>
                  <label>
                    <CustomRadio
                      size="small"
                      sx={classes.radioRoot}
                      checked={depositeCardDisburseFeature === DIRECT_DEPOSITE_RADIO_TEXT_NO}
                      onChange={handleDepositeCardRequiredRadio}
                      onKeyDown={handleDepositeCardRequiredRadioOnEnter}
                      value={DIRECT_DEPOSITE_RADIO_TEXT_NO}
                      inputProps={{
                        'data-testid': 'second_checkbox_testid',
                      }}
                      name="direct deposit"
                    />
                    <Typography
                      variant="subtitle1"
                      aria-label={t(DIRECT_DEPOSITE_RADIO_TEXT_NO, {
                        defaultValue: DIRECT_DEPOSITE_RADIO_TEXT_NO,
                      })}
                      sx={classes.radioLabelStyle}
                    >
                      {t(DIRECT_DEPOSITE_RADIO_TEXT_NO, {
                        defaultValue: DIRECT_DEPOSITE_RADIO_TEXT_NO,
                      })}
                    </Typography>
                  </label>
                </Box>
              </Box>
            </Box>
          </>
        )}
        <Grid container>
          {(productMapping(productName) === 'Libre' ||
            productMapping(productName) === 'Ahorra' ||
            productMapping(productName) === 'Elite Account') && (
            <>
              <Grid size={{ xs: 12 }} sx={classes.titleborderdepositeBor}>
                <Box
                  component="span"
                  sx={classes.quesTitleStyleDeposite}
                  aria-label={t('Statements', {
                    defaultValue: 'Statements',
                  })}
                >
                  {t('Statements', {
                    defaultValue: 'Statements',
                  })}
                </Box>
              </Grid>
              <Grid
                size={{ xs: 12 }}
                style={{ display: 'flex', alignItems: 'center', marginTop: '11px' }}
              >
                <Typography
                  variant="subtitle1"
                  sx={classes.eStatementDesign}
                  style={{ marginTop: '5px' }}
                >
                  {t(E_STATEMENTS, {
                    defaultValue: E_STATEMENTS,
                  })}
                </Typography>
              </Grid>

              {!isMobile600 && (
                <Grid
                  // id="eStatementDisclaimerId"
                  size={{ xs: 12, md: 12 }}
                  sx={classes.marginStatement}
                >
                  {language === 'EN' && (
                    <>
                      <Box component="span" sx={classes.quesTitleSubHeadingStyle}>
                        {t(
                          'Your account includes e-Statement. You will be able to access your account statements electronically and free of charge when you sign up for our',
                          {
                            defaultValue:
                              'Your account includes e-Statement. You will be able to access your account statements electronically and free of charge when you sign up for our',
                            nsSeparator: '|',
                          }
                        )}
                      </Box>
                      <Box component="span" sx={classes.onlinetext}>
                        {t('prg', {
                          defaultValue: ' Online Banking.',
                          nsSeparator: '|',
                        })}
                      </Box>
                      <Box component="span" sx={classes.quesTitleSubHeadingStyle}>
                        {t(' Register today to avoid charges.', {
                          defaultValue: ' Register today to avoid charges.',
                          nsSeparator: '|',
                        })}
                      </Box>
                    </>
                  )}
                  {language === 'ES' && (
                    <>
                      <Box component="span" sx={classes.quesTitleSubHeadingStyle}>
                        {t(
                          'Tu cuenta incluye e-Statement. Podrás acceder a tus estados de cuenta de forma electrónica y gratuita cuando te registras en nuestra',
                          {
                            defaultValue:
                              'Tu cuenta incluye e-Statement. Podrás acceder a tus estados de cuenta de forma electrónica y gratuita cuando te registras en nuestra',
                            nsSeparator: '|',
                          }
                        )}
                      </Box>

                      <Box component="span" sx={classes.onlinetext}>
                        {t(' Banca Online', {
                          defaultValue: ' Banca Online',
                          nsSeparator: '|',
                        })}
                      </Box>

                      <Box component="span" sx={classes.quesTitleSubHeadingStyle}>
                        {t(', Register today to avoid charges', {
                          defaultValue: ', Subscríbete hoy para evitar cargos.',
                          nsSeparator: '|',
                        })}
                      </Box>
                    </>
                  )}
                </Grid>
              )}

              {isMobile600 && (
                <Grid
                  size={{ xs: 12, md: 12 }}
                  sx={classes.marginStatement}
                  style={{ marginBottom: 0 }}
                >
                  <Box component="span" sx={classes.quesTitleSubHeadingStyle}>
                    {t('Your name ', {
                      defaultValue: 'Your ',
                      nsSeparator: '|',
                    })}
                    {t(returnproduct(), {
                      defaultValue: returnproduct(),
                      nsSeparator: '|',
                    })}
                    {t(' includes e-Statement!', {
                      defaultValue: ' includes e-Statement!',
                      nsSeparator: '|',
                    })}
                  </Box>

                  {isReadlessEstatement && isMobile600 && language === 'EN' && (
                    <>
                      <Box component="span" sx={classes.quesTitleSubHeadingStyle}>
                        {t(
                          'Your account includes e-Statement. You will be able to access your account statements electronically and free of charge when you sign up for our',
                          {
                            defaultValue:
                              'Your account includes e-Statement. You will be able to access your account statements electronically and free of charge when you sign up for our',
                            nsSeparator: '|',
                          }
                        )}
                      </Box>

                      <Box component="span" sx={classes.onlinetext}>
                        {t('prg', {
                          defaultValue: ' Online Banking.',
                          nsSeparator: '|',
                        })}
                      </Box>

                      <Box component="span" sx={classes.quesTitleSubHeadingStyle}>
                        {t(' Register today to avoid charges.', {
                          defaultValue: ' Register today to avoid charges.',
                          nsSeparator: '|',
                        })}
                      </Box>
                    </>
                  )}
                  {isReadlessEstatement && isMobile600 && language === 'ES' && (
                    <>
                      <Box component="span" sx={classes.quesTitleSubHeadingStyle}>
                        {t(
                          'Tu cuenta incluye e-Statement. Podrás acceder a tus estados de cuenta de forma electrónica y gratuita cuando te registras en nuestra',
                          {
                            defaultValue:
                              'Tu cuenta incluye e-Statement. Podrás acceder a tus estados de cuenta de forma electrónica y gratuita cuando te registras en nuestra',
                            nsSeparator: '|',
                          }
                        )}
                      </Box>

                      <Box component="span" sx={classes.onlinetext}>
                        {t(' Banca Online', {
                          defaultValue: ' Banca Online',
                          nsSeparator: '|',
                        })}
                      </Box>

                      <Box component="span" sx={classes.quesTitleSubHeadingStyle}>
                        {t(', Register today to avoid charges', {
                          defaultValue: ', Subscríbete hoy para evitar cargos.',
                          nsSeparator: '|',
                        })}
                      </Box>
                    </>
                  )}
                </Grid>
              )}

              {isMobile600 && (
                <Box
                  component="a"
                  href="#"
                  sx={classes.readMore}
                  onClick={togglereadMoreAnotherEstatement}
                >
                  {isReadlessEstatement
                    ? t(' Read less...', {
                        defaultValue: ' Read less...',
                      })
                    : t(' Read more...', {
                        defaultValue: ' Read more...',
                      })}
                </Box>
              )}

              <Grid
                size={{ xs: 12, md: 12 }}
                sx={classes.marginStatement}
                // id="eStatementDisclaimerId2"
              >
                <Box component="span" sx={classes.quesTitleSubHeadingStyle}>
                  {t(
                    'If you prefer your statement on paper, you will have a monthly service charge of $2.00.',
                    {
                      defaultValue:
                        'If you prefer your statement on paper, you will have a monthly service charge of $2.00.',
                      nsSeparator: '|',
                    }
                  )}
                </Box>
              </Grid>
            </>
          )}

          {(productMapping(productName) === 'Libre' ||
            productMapping(productName) === 'Ahorra' ||
            productMapping(productName) === 'Elite Account') && (
            <Grid size={{ xs: 12, md: 12 }}>
              <Box sx={classes.outerDivAnother}>
                <div>
                  <Box
                    component="img"
                    id="signerFeeId"
                    sx={classes.imgDivDesign}
                    src={NewAddressImage}
                    alt={t(
                      'Accounts whose primary signer is older than 65 years of age, are exempt from this fee.',
                      {
                        defaultValue:
                          'Accounts whose primary signer is older than 65 years of age, are exempt from this fee.',
                      }
                    )}
                    aria-label={t(
                      'Accounts whose primary signer is older than 65 years of age, are exempt from this fee.',
                      {
                        defaultValue:
                          'Accounts whose primary signer is older than 65 years of age, are exempt from this fee.',
                      }
                    )}
                  />
                </div>
                <div>
                  <Box component="span" sx={classes.textHeadingIMG}>
                    {t(
                      'Accounts whose primary signer is older than 65 years of age, are exempt from this fee.',
                      {
                        defaultValue:
                          'Accounts whose primary signer is older than 65 years of age, are exempt from this fee.',
                      }
                    )}
                  </Box>
                </div>
              </Box>
            </Grid>
          )}
          {productMapping(productName) === 'Elite Account' && (
            <Grid size={{ xs: 12, md: 12 }} sx={classes.outerDivStatement}>
              <div>
                <Box
                  component="img"
                  id="combStatementId"
                  sx={classes.imgDivDesign}
                  src={NewAddressImage}
                  alt={t('Combined statement:', {
                    defaultValue: 'Combined statement:',
                  })}
                  aria-describedby="combStatementDisclaimerId"
                />
              </div>
              <div>
                <Typography sx={classes.eStatementDesign}>
                  {t('Combined statement:', {
                    defaultValue: 'Combined statement:',
                    nsSeparator: '|',
                  })}
                </Typography>
                <Typography
                  sx={classes.textHeadingIMG}
                  style={{ marginTop: '8px' }}
                  id="combStatementDisclaimerId"
                >
                  {t(COMBINED_STATEMENT, {
                    defaultValue: COMBINED_STATEMENT,
                  })}
                </Typography>
              </div>
            </Grid>
          )}
        </Grid>
        {productMapping(productName) === 'Elite Account' && (
          <Grid
            container
            role="application"
            aria-roledescription={t('Automatic Transfers', {
              defaultValue: 'Automatic Transfers',
            })}
          >
            <Grid size={{ xs: 12 }} sx={classes.titleborderdepositeBor}>
              <Box
                component="span"
                sx={classes.quesTitleStyleDeposite}
                aria-label={t('Automatic Transfers', {
                  defaultValue: 'Automatic Transfers',
                })}
              >
                {t('Automatic Transfers', {
                  defaultValue: 'Automatic Transfers',
                })}
              </Box>
            </Grid>

            <Grid size={{ xs: 12, md: 12 }} sx={classes.outerDivAutoTransfer}>
              <div>
                <Box
                  component="img"
                  id="defTransferId"
                  sx={classes.imgDivDesign}
                  src={NewAddressImage}
                  alt={t('Deficit transfer', {
                    defaultValue: 'Deficit transfer',
                  })}
                  aria-label={t('Deficit transfer', {
                    defaultValue: 'Deficit transfer',
                  })}
                  aria-describedby="deficitTransferDisclaimer"
                />
              </div>
              <div>
                <Typography
                  sx={classes.eStatementDesignArial}
                  style={
                    isMobile600
                      ? {
                          marginBottom: '9px',
                        }
                      : {
                          marginBottom: '18px',
                        }
                  }
                >
                  {t('Deficit transfer', {
                    defaultValue: 'Deficit transfer',
                  })}
                </Typography>
                {!isMobile600 && (
                  <Typography
                    sx={classes.textHeadingIMG}
                    style={{
                      marginBottom: '30px',
                    }}
                    id="deficitTransferDisclaimer"
                  >
                    {t(DEFICIT_TRANSFER_TEXT, {
                      defaultValue: DEFICIT_TRANSFER_TEXT,
                    })}
                  </Typography>
                )}
                {isMobile600 && (
                  <Typography
                    sx={classes.textHeadingIMG}
                    style={{
                      marginBottom: '33px',
                    }}
                  >
                    {t(
                      'This account requires maintaining a minimum amount of $1,000.00 in the checking section, to help.',
                      {
                        defaultValue:
                          'This account requires maintaining a minimum amount of $1,000.00 in the checking section, to help.',
                      }
                    )}
                    {isReadless && isMobile600 && (
                      <span>
                        {t(
                          'you maintain this balance, we will automatically transfer from your savings account the necessary amount to maintain this limit as you make transactions.',
                          {
                            defaultValue:
                              'you maintain this balance, we will automatically transfer from your savings account the necessary amount to maintain this limit as you make transactions.',
                          }
                        )}
                      </span>
                    )}
                    {isMobile600 && (
                      <Box component="a" href="#" sx={classes.readMore} onClick={togglereadMore}>
                        {isReadless
                          ? t(' Read less...', {
                              defaultValue: ' Read less...',
                            })
                          : t(' Read more...', {
                              defaultValue: ' Read more...',
                            })}
                      </Box>
                    )}
                  </Typography>
                )}
              </div>
            </Grid>
            <Grid size={{ xs: 12, md: 12 }} sx={classes.outerDivAutoTransfer}>
              <div>
                <Box
                  component="img"
                  id="excessTransferId"
                  sx={classes.imgDivDesign}
                  src={NewAddressImage}
                  alt={t('Excess transfer', {
                    defaultValue: 'Excess transfer',
                  })}
                  aria-label={t('Excess transfer', {
                    defaultValue: 'Excess transfer',
                  })}
                  aria-describedby="excessTransferDisclaimer excessTransferDisclaimer2"
                />
              </div>
              <div>
                <Typography
                  sx={classes.eStatementDesignArial}
                  style={
                    isMobile600
                      ? {
                          marginBottom: '9px',
                        }
                      : {
                          marginBottom: '18px',
                        }
                  }
                >
                  {t('Excess transfer', {
                    defaultValue: 'Excess transfer',
                  })}
                </Typography>
                {!isMobile600 && (
                  <Typography
                    sx={classes.textHeadingIMG}
                    id="excessTransferDisclaimer"
                    style={
                      isMobile600
                        ? {
                            marginTop: '9px',
                            display: 'inline-grid',
                          }
                        : {
                            display: 'inline-flex',
                          }
                    }
                  >
                    {t(EXCESS_TRANSFER_TEXT, {
                      defaultValue: EXCESS_TRANSFER_TEXT,
                    })}
                  </Typography>
                )}
                {isMobile600 && (
                  <Typography sx={classes.textHeadingIMG}>
                    {t(
                      'In order for you to earn the highest interest rate payments on your savings, we can automatically',
                      {
                        defaultValue:
                          'In order for you to earn the highest interest rate payments on your savings, we can automatically',
                      }
                    )}
                    {isReadlessAnother && isMobile600 && (
                      <span>
                        {t(
                          ' transfer the excess of the amount you want. Tell us if you prefer to activate this function along with the maximum amount and we will take care of the rest.',
                          {
                            defaultValue:
                              ' transfer the excess of the amount you want. Tell us if you prefer to activate this function along with the maximum amount and we will take care of the rest.',
                          }
                        )}
                      </span>
                    )}
                    {isMobile600 && (
                      <Box
                        component="a"
                        href="#"
                        sx={classes.readMore}
                        onClick={togglereadMoreAnother}
                      >
                        {isReadlessAnother
                          ? t(' Read less...', {
                              defaultValue: ' Read less...',
                            })
                          : t(' Read more...', {
                              defaultValue: ' Read more...',
                            })}
                      </Box>
                    )}
                  </Typography>
                )}
              </div>
            </Grid>
          </Grid>
        )}
        {productMapping(productName) === 'Elite Account' && (
          <Box
            style={{
              display: isMobile ? 'inline-grid' : 'inline-flex',
            }}
            sx={classes.excessTransfer}
          >
            <div style={{ marginBottom: isMobile ? '23px' : '0px', display: 'flex' }}>
              <label>
                <CustomRadio
                  size="small"
                  sx={classes.radioRoot}
                  checked={excessTransferFeature === DIRECT_DEPOSITE_RADIO_TEXT}
                  onChange={handleExcessCardRequiredRadio}
                  onKeyDown={handleExcessCardRequiredRadioOnEnter}
                  value={DIRECT_DEPOSITE_RADIO_TEXT}
                  inputProps={{
                    'data-testid': 'excess_transfer_yes_testid',
                  }}
                  name="excess transfer"
                />
                <Typography
                  style={{ marginRight: '16px' }}
                  aria-label={t(DIRECT_DEPOSITE_RADIO_TEXT, {
                    defaultValue: DIRECT_DEPOSITE_RADIO_TEXT,
                  })}
                  sx={classes.radioLabelStyle}
                >
                  {t(DIRECT_DEPOSITE_RADIO_TEXT, {
                    defaultValue: DIRECT_DEPOSITE_RADIO_TEXT,
                  })}
                </Typography>
              </label>
            </div>
            <div style={{ display: 'flex' }}>
              <label>
                <CustomRadio
                  size="small"
                  sx={classes.radioRoot}
                  checked={excessTransferFeature === DIRECT_DEPOSITE_RADIO_TEXT_NO}
                  onChange={handleExcessCardRequiredRadio}
                  onKeyDown={handleExcessCardRequiredRadioOnEnter}
                  value={DIRECT_DEPOSITE_RADIO_TEXT_NO}
                  inputProps={{
                    'data-testid': 'excess_transfer_no_testid',
                  }}
                  name="excess transfer"
                />
                <Typography
                  aria-label={t(DIRECT_DEPOSITE_RADIO_TEXT_NO, {
                    defaultValue: DIRECT_DEPOSITE_RADIO_TEXT_NO,
                  })}
                  sx={classes.radioLabelStyle}
                >
                  {t(DIRECT_DEPOSITE_RADIO_TEXT_NO, {
                    defaultValue: DIRECT_DEPOSITE_RADIO_TEXT_NO,
                  })}
                </Typography>
              </label>
            </div>
          </Box>
        )}
        {productMapping(productName) === 'Elite Account' && (
          <Grid size={{ xs: 12, md: 6 }}>
            {/* <Grid  size={{ xs: 12 }}> */}
            <CustomInput
              id="excessAmtVal"
              dataTestId="excess-Amt-id"
              inputLabelAriaLabel={t('Excess limit amount', {
                defaultValue: 'Excess limit amount',
              })}
              disabled={excessTransferFeature === DIRECT_DEPOSITE_RADIO_TEXT_NO}
              label={t('Excess limit amount', {
                defaultValue: 'Excess limit amount',
              })}
              required={excessTransferFeature === DIRECT_DEPOSITE_RADIO_TEXT}
              handleChange={handleChangeExcessAmt}
              placeholder={t('Min amount $1,000.00', {
                defaultValue: 'Min amount $1,000.00',
              })}
              fullWidth
              inputProps={{
                maxLength: 9,
                inputMode: 'numeric',
                'data-testid': 'excess-Amt-id',
              }}
              value={commonUtility(excessAmt.excessAmtVal)}
              error={commonUtility(excessAmtError.excessAmt)}
            />
            <Box
              component="span"
              sx={classes.error_message}
              role="alert"
              data-testid="excess-Amt-error"
            >
              {t(`${excessAmtError?.excessAmtVal}`, {
                defaultValue: `${excessAmtError?.excessAmtVal}`,
              })}
            </Box>
          </Grid>
        )}
        {productMapping(productName) === 'Elite Account' && (
          <Grid
            size={{ xs: 12 }}
            // aria-label={t(EXCESS_TRANSFER_NOTE, {
            //   defaultValue: EXCESS_TRANSFER_NOTE,
            //   nsSeparator: '|',
            // })}
            id="excessTransferDisclaimer2"
          >
            {' '}
            <Typography sx={classes.orangeNote}>
              {t(EXCESS_TRANSFER_NOTE, {
                defaultValue: EXCESS_TRANSFER_NOTE,
                nsSeparator: '|',
              })}
            </Typography>
          </Grid>
        )}
        {productMapping(productName) === 'Libre' && (
          <Box
            role="application"
            aria-roledescription={t('Debit Card', {
              defaultValue: 'Debit Card',
            })}
            aria-describedby="debitCardDisclaimerId"
            sx={classes.debCard}
          >
            <Grid size={{ xs: 12 }} style={{ borderTop: '1px solid #E6E6E6', paddingTop: '30px' }}>
              <Box
                component="span"
                sx={classes.quesTitleStyleDeposite}
                aria-label={t('Account Funding', {
                  defaultValue: 'Account Funding',
                })}
              >
                {t('Initial Deposit', {
                  defaultValue: 'Initial Deposit',
                })}
              </Box>
            </Grid>
            <Grid container>
              <Grid
                id="debitCardDisclaimerId"
                size={{ xs: 12, md: 12 }}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <Box component="span" sx={classes.quesTitleSubHeadingStyle}>
                  {t('Would you like to make an initial deposit to your account at this moment?', {
                    defaultValue:
                      'Would you like to make an initial deposit to your account at this moment?',
                    nsSeparator: '|',
                  })}
                </Box>
              </Grid>
            </Grid>
            <Box
              style={{
                display: isMobile ? 'inline-grid' : 'inline-flex',
              }}
              sx={classes.radioLayoutDeposite}
            >
              <div style={{ marginBottom: isMobile ? '23px' : '0px', display: 'flex' }}>
                <label>
                  <CustomRadio
                    size="small"
                    sx={classes.radioRoot}
                    checked={isFundingRequired === DIRECT_DEPOSITE_RADIO_TEXT}
                    onChange={handleFundingCardRequiredRadio}
                    onKeyDown={handleFundingCardRequiredRadioOnEnter}
                    value={DIRECT_DEPOSITE_RADIO_TEXT}
                    inputProps={{
                      'data-testid': 'mail_my_card_testid',
                    }}
                    name="debit card"
                  />
                  <Typography
                    style={{ marginRight: '16px' }}
                    aria-label={t(DIRECT_DEPOSITE_RADIO_TEXT, {
                      defaultValue: DIRECT_DEPOSITE_RADIO_TEXT,
                    })}
                    sx={classes.radioLabelStyle}
                  >
                    {t(DIRECT_DEPOSITE_RADIO_TEXT, {
                      defaultValue: DIRECT_DEPOSITE_RADIO_TEXT,
                    })}
                  </Typography>
                </label>
              </div>
              <div style={{ display: 'flex' }}>
                <label>
                  <CustomRadio
                    size="small"
                    sx={classes.radioRoot}
                    checked={isFundingRequired === DIRECT_DEPOSITE_RADIO_TEXT_NO}
                    onChange={handleFundingCardRequiredRadio}
                    onKeyDown={handleFundingCardRequiredRadioOnEnter}
                    value={DIRECT_DEPOSITE_RADIO_TEXT_NO}
                    inputProps={{
                      'data-testid': 'second_checkbox_testid',
                    }}
                    name="debit card"
                  />
                  <Typography
                    aria-label={t(DIRECT_DEPOSITE_RADIO_TEXT_NO, {
                      defaultValue: DIRECT_DEPOSITE_RADIO_TEXT_NO,
                    })}
                    sx={classes.radioLabelStyle}
                  >
                    {t(DIRECT_DEPOSITE_RADIO_TEXT_NO, {
                      defaultValue: DIRECT_DEPOSITE_RADIO_TEXT_NO,
                    })}
                  </Typography>
                </label>
              </div>
            </Box>
          </Box>
        )}
      </Box>
      {/* new added */}
    </Layout>
  );
  const bundleFeature = () => (
    <NewLayout
      handleContinue={handleContinue}
      handleBack={back}
      stepValue={4}
      sx={{ paddingBottom: '80px' }}
      handleSaveApplication={handleSaveApplication}
      disableCondition={isValidating}
      backBtnTestid="backBtn_id"
      continueBtnTestid="continueBtn_id"
      screenLoading={isValidating}
    >
      <Grid
        container
        sx={[layoutClasses.mailingAddressSwitchContainer, layoutClasses.fullWidth]}
        data-page={FEATURE_INFO}
      >
        <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10 }} sx={layoutClasses.tooltipStyle}>
          <Typography
            component="h4"
            variant="subtitle1"
            sx={{ ...classes.sameSelectionTextStyle, color: theme?.palette?.primary?.main }}
          >
            {t(APPLY_TWO_ACCOUNTS, {
              defaultValue: APPLY_TWO_ACCOUNTS,
            })}
          </Typography>
        </Grid>

        <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2 }} sx={layoutClasses.switchPosition}>
          <CustomSwitch
            id="editHomeAddress"
            ariaLabelName={`${t(APPLY_TWO_ACCOUNTS, {
              defaultValue: APPLY_TWO_ACCOUNTS,
            })}`}
            defaultData={!!productAccountTypeFeature}
            ariaLabelledby="toggleone"
            handleClickCheckbox={(e) => {
              setProductAccountTypeFeature(!productAccountTypeFeature);
              setDebitCardDisburseFeature(false);
              setDebitCardDisburseFeatureSavings(false);
              setMasterDebitCardDisburseFeature(false);
              setMasterDebitCardDisburseFeatureSavings(false);
            }}
            isBundle={isBundle(productName)}
            dataTestId="editHomeAddress_testId"
          />
        </Grid>
      </Grid>
      {!productAccountTypeFeature ? (
        <CommonTab checkingProduct={ProductIndexFunc} savingProduct={ProductIndexFunc} />
      ) : (
        <>{ProductIndexFunc()}</>
      )}
    </NewLayout>
  );
  const featureInfoJsx = commonTernary(isBundle(productName), bundleFeature(), FeatureLayout());

  return (
    <>
      {featureInfoJsx}
      {isModalSaveLater && (
        <SaveAppContactInfo openModal={isModalSaveLater} currentPage={FEATURE_INFO} />
      )}
    </>
  );
};

export default withRouter(FeatureScreenProgresa);

FeatureScreenProgresa.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};
